import { Schema } from "effect";
import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { Authn } from "../authn";
import { Client } from "../../../schema/models";
import { BadRequest, InternalServerError, NotFound, Unauthorized } from "@superwall/api-schema-utils";
import { OneSignalPlayerId as OneSignalPlayerIdNS } from "@superwall/onesignal";
// Use the OneSignal Player ID schema from the onesignal package
const OneSignalPlayerId = OneSignalPlayerIdNS.Id;
// Application object schema
const ApplicationObject = Schema.Struct({
    applicationId: Schema.NumberFromString
}).pipe(Schema.annotations({
    title: "Application",
    description: "Application object containing ID"
}));
// Application ID array schema (for subscribe/unsubscribe)
const ApplicationIds = Schema.Array(ApplicationObject).pipe(Schema.annotations({
    title: "Applications",
    description: "Array of application objects to subscribe/unsubscribe from"
}));
// Subscription response schema (used for all endpoints)
const SubscriptionResponse = Schema.Struct({
    oneSignalPlayerId: OneSignalPlayerId,
    subscribedApplications: ApplicationIds.pipe(Schema.annotations({
        description: "Array of application objects the user is subscribed to"
    }))
}).pipe(Schema.annotations({
    title: "Subscription Response",
    description: "User's OneSignal subscription information"
}));
// Subscribe request schema
const SubscribeRequest = Schema.Struct({
    applications: ApplicationIds.pipe(Schema.filter((arr)=>arr.length <= 10, {
        message: ()=>"Cannot subscribe to more than 10 applications at once"
    }), Schema.annotations({
        jsonSchema: {
            type: "array",
            maxItems: 10,
            items: {
                type: "object",
                properties: {
                    applicationId: {
                        type: "string"
                    }
                },
                required: [
                    "applicationId"
                ]
            }
        }
    }))
}).pipe(Schema.annotations({
    title: "Subscribe Request",
    description: "Request to subscribe user to applications"
}));
// Unsubscribe request schema  
const UnsubscribeRequest = Schema.Struct({
    applications: ApplicationIds
}).pipe(Schema.annotations({
    title: "Unsubscribe Request",
    description: "Request to unsubscribe user from applications"
}));
export default HttpApiGroup.make("clientv1").annotate(OpenApi.Title, "Client V1").add(HttpApiEndpoint.get("getMeta")`/meta`.setUrlParams(Schema.Struct({
    platform: Schema.Literal("ios"),
    version: Schema.String
})).addSuccess(Client.Meta).annotate(OpenApi.Summary, "Get Meta")).add(HttpApiEndpoint.get("getSubscriptions")`/:playerId/subscriptions`.setPath(Schema.Struct({
    playerId: OneSignalPlayerId
})).addSuccess(SubscriptionResponse).addError(NotFound).addError(BadRequest).addError(InternalServerError).annotate(OpenApi.Summary, "Get OneSignal Subscriptions").annotate(OpenApi.Description, "Get user's OneSignal subscription information by player ID")).add(HttpApiEndpoint.post("subscribe")`/:playerId/subscriptions/subscribe`.setPath(Schema.Struct({
    playerId: OneSignalPlayerId
})).setPayload(SubscribeRequest).addSuccess(SubscriptionResponse).addError(BadRequest).addError(Unauthorized).addError(InternalServerError).annotate(OpenApi.Summary, "Subscribe to Applications").annotate(OpenApi.Description, "Subscribe user to up to 10 applications via OneSignal")).add(HttpApiEndpoint.post("unsubscribe")`/:playerId/subscriptions/unsubscribe`.setPath(Schema.Struct({
    playerId: OneSignalPlayerId
})).setPayload(UnsubscribeRequest).addSuccess(SubscriptionResponse).addError(BadRequest).addError(Unauthorized).addError(InternalServerError).annotate(OpenApi.Summary, "Unsubscribe from Applications").annotate(OpenApi.Description, "Unsubscribe user from applications via OneSignal")).prefix("/v1/client").middleware(Authn);
